export default __webpack_public_path__ + "static/media/02-dashboard-min.75e50284.png";